import Vue from 'vue'
import VueRouter from 'vue-router'
import HomePage from '@views/home'
import RegistrationPage from '@views/registration'
import RegistrationDetail from '@views/registration/registrationDetail'
import WechatpayPage from '@/views/registration/wechatpayDesktop'
import MeetingPage from '@views/meeting'
import MeetingDetails from '@views/meeting/details.vue'
import PapersPage from '@views/papers'
import QuestionsPage from '@views/questions'
import ProjectVisitPage from '@views/project'
import ProjectDetail from '@views/project/details.vue'

/* 会场信息静态路由 */
import VenuePage from '@views/meeting/components/venue.vue'
import TrafficPage from '@views/meeting/components/traffic.vue'
import GuestPage from '@views/meeting/components/guest.vue'
import GuestDetailPage from '@views/meeting/components/guestDetailnew.vue'
import MeetDetailPage from '@views/meeting/components/meetDetail.vue'
import InvoicePage from '@views/registration/invoice.vue'
import RefundPage from '@views/registration/refund.vue'
import OrgDetailPage from '@views/meeting/components/orgDetail.vue'
import informDetail from '@views/meeting/components/informDetail.vue'

import informList from '@views/meeting/components/list/informList.vue'
import agendaList from '@views/meeting/components/list/agendaList.vue'
import hotelList from '@views/meeting/components/list/hotelList.vue'
import noticeList from '@views/meeting/components/list/noticeList.vue'
import siteList from '@views/meeting/components/list/siteList.vue'
import affairsList from '@views/meeting/components/list/affairsList.vue'

import hintDetail from '@views/meeting/components/hintDetail.vue'
import noticeDetail from '@views/meeting/components/noticeDetail.vue'
import hotelDetail from '@views/meeting/components/hotelDetail.vue'
import scheduleDetail from '@views/meeting/components/scheduleDetail.vue'
import diningDetail from '@views/meeting/components/diningDetail.vue'
import linkDetail from '@views/meeting/components/linkDetail.vue'
import trafficDetail from '@views/meeting/components/trafficDetail.vue'
import introDetail from '@views/meeting/components/introDetail.vue'
import transhipDetail from '@views/meeting/components/transhipDetail.vue'



Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'HomePage',
    component: HomePage,
    meta: {
      active: 'HomePage'
    }
  },
  {
    path: '/registration',
    name: 'RegistrationPage',
    component: RegistrationPage,
    meta: {
      active: 'RegistrationPage'
    }
  },
  {
    path: '/registrationDetail',
    name: 'RegistrationDetail',
    component: RegistrationDetail,
    // meta: {
    //   active: 'RegistrationPage'
    // }
  },
  {
    path: '/invoice',
    name: 'InvoicePage',
    component: InvoicePage,
    meta: {
      active: 'InvoicePage'
    }
  },
  {
    path: '/wechatpay',
    name: 'WechatpayPage',
    component: WechatpayPage,
    meta: {
      active: 'WechatpayPage'
    }
  },
  {
    path: '/refund',
    name: 'RefundPage',
    component: RefundPage,
    meta: {
      active: 'RefundPage'
    }
  },
  {
    path: '/meeting',
    name: 'MeetingPage',
    component: MeetingPage,
    meta: {
      active: 'MeetingPage'
    }
  },
  {
    path: '/meetingDetails',
    name: 'MeetingDetails',
    component: MeetingDetails,
    meta: {
      active: 'MeetingPage'
    }
  },

  {
    path: '/papers',
    name: 'PapersPage',
    component: PapersPage,
    meta: {
      active: 'PapersPage'
    }
  },
  {
    path: '/projectVisit',
    name: 'ProjectVisitPage',
    component: ProjectVisitPage,
    meta: {
      active: 'ProjectVisitPage'
    }
  },
  {
    path: '/projectDetail',
    name: 'ProjectDetail',
    component: ProjectDetail,
    meta: {
      active: 'ProjectVisitPage'
    }
  },
  {
    path: '/questions',
    name: 'QuestionsPage',
    component: QuestionsPage,
    meta: {
      active: 'QuestionsPage'
    }
  },


  /* 会场信息静态 */
  {
    path: '/venue',
    name: 'VenuePage',
    component: VenuePage,
    meta: {
      active: 'MeetingPage'
    }
  },
  {
    path: '/traffic',
    name: 'TrafficPage',
    component: TrafficPage,
    meta: {
      active: 'MeetingPage'
    }
  },
  {
    path: '/guest',
    name: 'GuestPage',
    component: GuestPage,
    meta: {
      active: 'MeetingPage'
    }
  },
  {
    path: '/guestDetail',
    name: 'GuestDetailPage',
    component: GuestDetailPage,
    meta: {
      active: 'MeetingPage'
    }
  },

  {
    path: '/meetDetail',
    name: 'MeetDetailPage',
    component: MeetDetailPage,
  },

  {
    path: '/orgDetail',
    name: 'OrgDetailPage',
    component: OrgDetailPage,
  },
//通知
  {
    path: '/informDetail',
    name: 'informDetailPage',
    component: informDetail,
  },
  {
    path: '/informList',
    name: 'informListPage',
    component: informList,
  },

//参会须知
  {
    path: '/noticeList',
    name: 'noticeListPage',
    component: noticeList,
  },
  {
    path: '/hintDetail',
    name: 'hintDetailPage',
    component: hintDetail,
  },
  {
    path: '/noticeDetail',
    name: 'noticeDetailPage',
    component: noticeDetail,
  },

  //会场信息
  {
    path: '/siteList',
    name: 'siteListPage',
    component: siteList,
  },
  //酒店信息
  {
    path: '/hotelList',
    name: 'hotelListPage',
    component: hotelList,
  },
  {
    path: '/hotelDetail',
    name: 'hotelDetailPage',
    component: hotelDetail,
  },
  {
    path: '/scheduleDetail',
    name: 'scheduleDetailPage',
    component: scheduleDetail,
  },
  //议程信息
  {
    path: '/agendaList',
    name: 'agendaListPage',
    component: agendaList,
  },
  //事务信息
  {
    path: '/affairsList',
    name: 'affairsListPage',
    component: affairsList,
  },
  {
    path: '/diningDetail',
    name: 'diningDetailPage',
    component: diningDetail,
  },
  {
    path: '/linkDetail',
    name: 'linkDetailPage',
    component: linkDetail,
  },
  //会场信息
  {
    path: '/trafficDetail',
    name: 'trafficDetail',
    component: trafficDetail,
  },
  {
    path: '/introDetail',
    name: 'introDetail',
    component: introDetail,
  },
  {
    path: '/transhipDetail',
    name: 'transhipDetail',
    component: transhipDetail,
  }

]

const router = new VueRouter({
  // mode: 'history',
  // base: process.env.BASE_URL,
  routes
})

export default router;
